import * as types from './action-types';
import store from '../../../../store/src/store';

const opts = {
  delay: 0
};

export const CloseModal = ({ delay } = opts, modalConfig = {}) => {
  const { dashboardModal } = store.getState();
  const cb =
    modalConfig?.closeModalCallback || dashboardModal.closeModalCallback;

  if (delay > 0) {
    setTimeout(
      () =>
        store.dispatch({
          type: types.DASHBOARD_MODAL_CLOSED
        }),
      delay
    );
  } else {
    store.dispatch({
      type: types.DASHBOARD_MODAL_CLOSED
    });
  }

  return typeof cb === 'function' && cb(modalConfig?.payload);
};

export const HideModalLoadingSpinner = ({ delay, modalConfig } = opts) => {
  setTimeout(
    () =>
      store.dispatch({
        type: types.DASHBOARD_MODAL_LOADED,
        payload: modalConfig
      }),
    delay
  );
};

export const ShowModalLoadingSpinner = () =>
  store.dispatch({
    type: types.DASHBOARD_MODAL_LOADING
  });

export const OpenModal = modalConfig => {
  ShowModalLoadingSpinner();
  store.dispatch({
    type: types.DASHBOARD_MODAL_OPENED,
    payload: {
      ...modalConfig
    }
  });

  return setTimeout(
    () => modalConfig.awaitModalChildLoad || HideModalLoadingSpinner(),
    500
  );
};
